<template>
  <div class="ai-question-group" v-if="group.questions.length !== 0">
    <button
        type="button"
        class="ai-question-group__header"
        @click="isOpen = !isOpen"
    >
      <span>
        {{ group.label }}
      </span>
      <span>
        <span class="ai-question-group__selected-count">{{ selectedQuestionsCount }}/{{ group.questions.length }} options</span>
        <i class="material-icons">{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i>
      </span>
    </button>

    <div v-if="isOpen" class="ai-question-group__questions">
      <question-list-item
          v-for="question in group.questions"
          :key="question.id"
          :question="question"
          :selected="isSelected(question.id)"
          :editable="question.custom"
          :deletable="question.custom && question.deletable"
          @toggle="$emit('toggle-question', question)"
          @edit="$emit('edit-question', question)"
          @delete="$emit('delete-question', question)"
      />
    </div>
  </div>
</template>

<script>
import QuestionListItem from './QuestionListItem.vue'

export default {
  name: 'QuestionGroupAccordion',
  components: {
    QuestionListItem,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    selectedQuestionIds: {
      type: Array,
      default: () => [],
    },
    openByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.openByDefault,
    }
  },
  methods: {
    isSelected(questionId) {
      return this.selectedQuestionIds.includes(questionId)
    },
  },
  computed: {
    selectedQuestionsCount() {
      return this.group.questions.filter((question) => this.isSelected(question.id)).length
    }
  }
}
</script>

<style lang="scss" scoped>

.ai-question-group {
  padding: 15px;
  border-radius: 10px;
  border: 1px solid var(--v-gray15Color-base);
}

.ai-question-group__header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background: transparent;
  color: var(--v-mainColor-base);
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  text-align: left;

  i {
    font-size: 24px;
  }

  .ai-question-group__selected-count {
    font-weight: 400;
    color: var(--v-darkGrayColor-base);
  }
}

.ai-question-group__questions {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 14px;
}
</style>
